<template>
  <div class="checkout-overlay-combo-holder">
    <ul class="checkout-overlay-combo">
      <slot />
    </ul>
  </div>
</template>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  .checkout-overlay-combo-holder {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    overflow-y: scroll;
    flex: 1;
    position: relative;
  }

  .checkout-overlay-combo {
    padding: 0;
    margin: 0;
    list-style: none;
    width: 100%;
    border-radius: 4px;
  }
</style>

<script>
  export default {
    name: 'checkout-overlay-combo'
  }
</script>
